import { createHash } from "crypto";
export const ensurePrefix = (str: string, prefix: string) =>
  str.startsWith(prefix) ? str : `${prefix}${str}`;
export const withoutSuffix = (str: string, suffix: string) =>
  str.endsWith(suffix) ? str.slice(0, -suffix.length) : str;
export const withoutPrefix = (str: string, prefix: string) =>
  str.startsWith(prefix) ? str.slice(prefix.length) : str;
export const handleTextSearch = (data: string[]) => {
  return data?.join(" ");
};
export const handleExpandPage = (data: string) => {
  return data
    ?.split(",")
    .map((part) => {
      if (part.includes("-")) {
        const [start, end] = part.split("-").map(Number);
        return Array.from(
          { length: end - start + 1 },
          (_, i) => start + i
        ).join(",");
      }
      return part;
    })
    .join(",");
};
export function generateUniqueCode(subEmail: string) {
  const raw = subEmail + Date.now() + Math.random();
  return raw
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0).toString(36), "")
    .slice(0, 8)
    .toUpperCase();
}

export const truncate = (str: string, n: number) => {
  if (!str) return "";
  return str.length > n ? str.slice(0, n - 1) + "…" : str;
};

export const generateVoucherCode = (voucherId: number) => {
  const secretKey = "PIXELCENTVOUCHER2025";
  const baseString = `${voucherId}-${Date.now()}-${Math.random()}-${secretKey}`;
  const hash = createHash("sha256").update(baseString).digest("hex");
  return hash.slice(0, 8).toUpperCase();
};

export const hash256 = (input: string) => {
  return createHash("sha256").update(input).digest("hex");
};
